import type { ComponentType } from 'react'

import { HStack, Text, VStack } from '@enechain/ecloud-designsystem'
import type { IconProps } from '@enechain/ecloud-designsystem'

import { iconSize } from '~/constants/iconSize'

/**
 * ⋯ メニュー項目の中身 (アイコン + ラベル)。
 *
 * design (`bidding/spot.html` の `wizard-more-menu-popup`) は各項目の先頭に
 * 20px の icon を置く (`.bid-create-menu-list .ecl-menu-item > svg
 * { width: 20px; height: 20px; flex-shrink: 0; color: var(--text-mid-emphasis) }`)。
 * 2026-09-01 デザイナー指摘「⋯ メニューの各項目に 8080 同様アイコンを出せないか」。
 *
 * 通常入札・ブロック入札の両タブで同じ見た目にするため 1 箇所に置く
 * (「通常とブロックで違う」がそもそもの指摘の発端なので、器を分けない)。
 *
 * icon は装飾で、意味はラベルが持つので `aria-hidden`。寸法は用途別 token
 * (`labeledButton` = 20px、ラベル付きの leading icon) を使う。
 *
 * `description` は項目を押せない理由の文 (`conventions.md`「操作できない時のボタンの扱い」:
 * 待てば操作できる前提の不足は、 非活性にして理由を文で画面上に常に表示する。
 * ツールチップ〈`title`〉だけにしない)。 ラベルの下に補助の文字で出す。
 */
export const SpotBidMenuItemContent = ({
  Icon,
  label,
  description,
}: {
  Icon: ComponentType<IconProps>
  label: string
  description?: string
}): React.ReactElement => (
  <HStack alignItems="center" gap={2}>
    <Icon boxSize={iconSize.labeledButton} aria-hidden="true" />
    {description === undefined ? (
      label
    ) : (
      <VStack alignItems="flex-start" gap={0}>
        {label}
        <Text
          as="span"
          textStyle="captionNormal"
          maxWidth="320px"
          color="Text.midEmphasis"
          whiteSpace="normal"
        >
          {description}
        </Text>
      </VStack>
    )}
  </HStack>
)
